module.exports = __webpack_public_path__ + "img/play-post-dark-1.90d94e75.jpg";